import {FC} from 'react';
import clsx from 'clsx';
import InputIncremental from 'components/Form/InputIncremental';
import {t} from 'ttag';

type MailpointManualInputProps = {
    hideMailPoints: boolean;
    isOnlyMultiplesOfTenAllowed: boolean;
    max: number;
    min: number;
};

const MailpointManualInput: FC<MailpointManualInputProps> = ({
    hideMailPoints,
    isOnlyMultiplesOfTenAllowed,
    max,
    min,
}) => (
    <div className={clsx('flex w-full gap-x-2', hideMailPoints && 'hidden')}>
        <InputIncremental
            className="min-w-0 flex-1"
            max={max}
            min={min}
            name="mailpoints"
            placeholder={`${min}-${max}`}
        />
        {isOnlyMultiplesOfTenAllowed && (
            <span className="mt-2 flex-none">× {t`10 MailPoints`}</span>
        )}
    </div>
);

export default MailpointManualInput;
